import UPModel from '@/models/imgup'
import bullet_screen from './bullet-screen'
import full_screen from './full-screen'
import player_process from './player-progress'
import skinLayout from './skinLayout'
import localKeyLock from '../localKeyLock'
const upModel = new UPModel()
const VIDEO_TIME_KEY = 'VIDEO_TIME_LAST_KEY'

/**
 *  vid : videoId
 *  autoplay: 是否自动播放;默认 false
 *  control: 是否展示进度条;默认 true
 *  mark : 跑马灯字符
 *  currentKeyValue: string 当前本地的缓存key
 */
export default async function (options) {
  let player = null
  let res = await upModel.aliInfo({ vid: options.vid })
  let aliinfo = res.data
  let realKey = localKeyLock(VIDEO_TIME_KEY, options.currentKeyValue)
  let components = [
    {
      // 清晰度
      name: 'QualityComponent',
      type: window.AliPlayerComponent.QualityComponent,
    },
    {
      name: 'bullet_screen',
      type: bullet_screen,
      args: [
        options.mark || '',
        { fontSize: '16px', color: 'rgba(76,76,76,0.2)', time: 10 },
        'random',
      ],
    },
    {
      name: 'full_screen',
      type: full_screen,
    },
    {
      name: 'player_processs',
      type: player_process,
      args: [{ duration: aliinfo.duration, lockKey: realKey }],
    },
  ]

  /**
   * 属性与方法说明：https://help.aliyun.com/document_detail/125572.htm?spm=a2c4g.11186623.2.17.131d10e4V9d1SC#task-1997027
   */
  player = new window.Aliplayer(
    {
      id: options.selector,
      width: '100%',
      height: '100%',
      autoplay: options.autoplay || false,
      preload: true,
      playsinline: true,
      vid: aliinfo.videoId,
      playauth: aliinfo.playAuth,
      cover: aliinfo.coverURL,
      language: 'zh-cn',
      encryptType: 1,
      showBuffer: true,
      defaultDefinition: 'LD',
      qualitySort: 'asc',
      format: 'm3u8',
      useH5Prism: true,
      controlBarVisibility: 'hover',
      showBarTime: 5000, // 控制栏自动隐藏时间（ms）
      skinLayout,
      components,
    },
    function (res) {
      window.player = res
      player = res
      player.setVolume(0.8)
      player.LOCK_KEY = realKey
      localStorage.getItem(realKey)
        ? player.seek(localStorage.getItem(realKey))
        : null
      // 对sdk自带的全屏按钮进行隐藏
      let full_screen_btn = document.querySelector('.prism-fullscreen-btn')
      full_screen_btn.style.display = 'none'
      // 对自定义的全屏按钮进行隐藏
      const custom_full_screen_btn = document.querySelector('#full_screen')
      options.noFullScreen ? (custom_full_screen_btn.style.display = 'none') : null
        
      player.videoTotalTime = aliinfo.duration
    }
  )
  player.videoTotalTime = aliinfo.duration
  player.on('sourceloaded', function (params) {
    var paramData = params.paramData
    var desc = paramData.desc
    var definition = paramData.definition
    player.getComponent('QualityComponent').setCurrentQuality(desc, definition)
  })

  return player
}
